export default __webpack_public_path__ + "static/media/Qualifications.166df72e.png";